import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackHelpCenterOpenQuickModalEventClick } from "@faire/web-api/events/helpCenter/click/openQuickModalEvent";
import { trackHelpCenterShortcutsClick } from "@faire/web-api/events/helpCenter/click/shortcuts";
import { Button } from "@faire/web/slate/Button";
import * as React from "react";
export var QuickActionButton = function QuickActionButton(_ref) {
  var _getRetailerToken, _getBrandToken;
  var actionType = _ref.actionType,
    setActionType = _ref.setActionType,
    origin = _ref.origin;
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  var trackOpenModalEvent = function trackOpenModalEvent() {
    trackHelpCenterOpenQuickModalEventClick(actionType.label);
    trackHelpCenterShortcutsClick(retailerToken, brandToken, origin, actionType.id);
    setActionType(actionType);
  };
  return /*#__PURE__*/React.createElement(Button, {
    style: {
      textAlign: "left"
    },
    variant: "tertiary",
    onClick: trackOpenModalEvent
  }, actionType.label);
};